import React from 'react';
import LazyImage from '../../components/LazyImage';

interface WhyUsSectionProps {
  onLearnMore?: () => void;
}

interface ContentSection {
  title: string;
  paragraphs: string[];
}

const WhyUsSection: React.FC<WhyUsSectionProps> = ({ onLearnMore }) => {
  const contentSections: ContentSection[] = [
    {
      title: "Welcome to The Wealthy Miner, your gateway to potentially life-changing returns in mining stocks",
      paragraphs: [
        "Welcome to The Wealthy Miner, your gateway to potentially <strong>life-changing returns</strong> in junior mining stocks. Led by Robert Bruggeman, a renowned former Bay Street research analyst and trader, our community empowers retail and high-net-worth investors to stack the odds for wealth in the high-stakes world of junior mining investment. With a proven track record turning AbraSilver <strong>$5M to $600M</strong>—Robert’s process helps you discover the best mining companies to invest in -  hunting <strong>5x, 10x, or even 100 baggers</strong>.",
      ]
    },
    {
      title: "Why Junior Mining Stocks?",
      paragraphs: [
        "Junior mining stocks can be the ultimate <strong>high-reward opportunity</strong>. These <strong>micro-cap companies, focused on gold, silver, uranium, and copper and more,</strong>, can deliver <strong>explosive returns</strong> when guided by the <strong>right expertise</strong>. But navigating this “mining casino” requires more than luck—it demands strategy. That’s where The Wealthy Miner shines. A veteran analyst, Robert Bruggeman simplifies complex technical data, from drill results to economic studies, to find the best mining companies to invest in.",
      ]
    }
  ];

  const handleImageClick = () => {
    // Handle image click - could open modal, navigate, etc.
    console.log('Mining workspace image clicked');
  };

  const renderContentSection = (section: ContentSection, index: number) => (
    <div key={index} className={`${index === 0 ? 'mb-20' : 'mb-8'} last:mb-0`}>
      <h2 className={`font-[700] text-[#000] mb-7 leading-[40px] ${
        index === 0 
          ? 'text-[30px] md:text-[40px] lg:text-[32px]' 
          : 'text-2xl md:text-3xl'
      }`}>
        {section.title}
      </h2>
      {section.paragraphs.map((paragraph, pIndex) => (
        <p 
          key={pIndex} 
          className="text-[16px] md:text-[20px] lg:text-[20px] text-[#000] leading-[29px] font-[400] mb-4 last:mb-0 text-justify"
          dangerouslySetInnerHTML={{ __html: paragraph }}
        />
      ))}
    </div>
  );

  return (
    <section className="pb-20 mx-auto px-4 md:px-10 lg:px-32 w-full bg-[#F6F6F6] pt-20">
      <div className="">
        {/* Mobile & Tablet Layout - Image between sections */}
        <div className="lg:hidden">
          {/* First section */}
          {renderContentSection(contentSections[0], 0)}
          
          {/* Image */}
          <div className="my-12">
            <div 
              className=""
              onClick={handleImageClick}
            >
              <LazyImage 
                src="/images/WhyUs.webp" 
                alt="Mining workspace with geological samples and workers" 
                className="w-full h-auto rounded-r-[25px]"
              />
            </div>
          </div>
          
          {/* Second section */}
          {renderContentSection(contentSections[1], 1)}
        </div>

        {/* Desktop Layout - Side by side */}
        <div className="hidden lg:grid lg:grid-cols-2 gap-12 items-center">
          {/* Text Content - Left Side */}
          <div className="space-y-8">
            {contentSections.map((section, index) => 
              renderContentSection(section, index)
            )}
          </div>

          {/* Image - Right Side */}
          <div className="lg:order-2 h-full">
            <div 
              className="h-full"
              onClick={handleImageClick}
            >
              <LazyImage 
                src="/images/WhyUs.webp" 
                alt="Mining workspace with geological samples and workers" 
                className="w-full h-full object-cover rounded-r-[25px]"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyUsSection;
